/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import logo from "../assets/images/chefducklogo.png";
import logo2 from "../assets/images/logo2.png";
import shop_pic2 from "../assets/images/shop/pic2.jpg";
import shop_pic3 from "../assets/images/shop/pic3.jpg";
import main_slide_pic1 from "../assets/images/main-slider/slider1/pic1.png";
import main_slide_img1 from "../assets/images/main-slider/slider1/img1.png";
import main_slide_img2 from "../assets/images/main-slider/slider1/img2.png";
import main_slide_img3 from "../assets/images/main-slider/slider1/img3.png";
import main_slide_thumb_pic1 from "../assets/images/main-slider/slider1/thumb/pic1.jpg";
import main_slide_thumb_pic2 from "../assets/images/main-slider/slider1/thumb/pic2.jpg";
import main_slide_thumb_pic3 from "../assets/images/main-slider/slider1/thumb/pic3.jpg";
import background_pic2 from "../assets/images/background/pic2.png";
import background_pic3 from "../assets/images/background/pic3.png";
import background_pic4 from "../assets/images/background/pic4.png";
import gallery_small_pic1 from "../assets/images/gallery/small/pic1.jpg";
import gallery_small_pic2 from "../assets/images/gallery/small/pic2.jpg";
import gallery_small_pic3 from "../assets/images/gallery/small/pic3.jpg";
import gallery_small_pic4 from "../assets/images/gallery/small/pic4.jpg";
import gallery_small_pic5 from "../assets/images/gallery/small/pic5.jpg";
import gallery_small_pic6 from "../assets/images/gallery/small/pic6.jpg";
import gallery_small_pic7 from "../assets/images/gallery/small/pic7.jpg";
import gallery_small_pic8 from "../assets/images/gallery/small/pic8.jpg";
import gallery_small_pic9 from "../assets/images/gallery/small/pic9.jpg";
import gallery_small_pic10 from "../assets/images/gallery/small/pic10.jpg";
import gallery_small_pic11 from "../assets/images/gallery/small/pic11.jpg";
import gallery_small_pic12 from "../assets/images/gallery/small/pic12.jpg";
import gallery_grid_pic1 from "../assets/images/gallery/grid/pic1.jpg";
import gallery_grid_pic2 from "../assets/images/gallery/grid2/pic2.jpg";
import gallery_grid_pic3 from "../assets/images/gallery/grid2/pic3.jpg";
import gallery_grid_pic4 from "../assets/images/gallery/grid2/pic4.jpg";
import gallery_grid_pic5 from "../assets/images/gallery/grid2/pic5.jpg";
import gallery_grid_pic6 from "../assets/images/gallery/grid2/pic6.jpg";
import gellry_grid2_pic1 from "../assets/images/gallery/grid2/pic1.jpg";
import gellry_grid2_pic2 from "../assets/images/gallery/grid2/pic2.jpg";
import gellry_grid2_pic3 from "../assets/images/gallery/grid2/pic3.jpg";
import gellry_grid2_pic4 from "../assets/images/gallery/grid2/pic4.jpg";
import background_pic1 from "../assets/images/background/pic1.png";
import testiminial_small_pic1 from "../assets/images/testimonial/small/pic1.jpg";
import testiminial_small_pic2 from "../assets/images/testimonial/small/pic2.jpg";
import testiminial_small_pic3 from "../assets/images/testimonial/small/pic3.jpg";
import testiminial_small_pic4 from "../assets/images/testimonial/small/pic4.jpg";
import testiminial_small_pic5 from "../assets/images/testimonial/small/pic5.jpg";
import testiminial_small_pic6 from "../assets/images/testimonial/small/pic6.jpg";
import image_team_pic1 from "../assets/images/team/pic1.jpg";
import image_team_pic2 from "../assets/images/team/pic2.jpg";
import image_team_pic3 from "../assets/images/team/pic3.jpg";
import image_team_pic4 from "../assets/images/team/pic4.jpg";
import image_team_pic5 from "../assets/images/team/pic5.jpg";
import image_team_pic6 from "../assets/images/team/pic6.jpg";
import image_team_pic7 from "../assets/images/team/pic7.jpg";
import image_team_pic8 from "../assets/images/team/pic8.jpg";
import image_team_pic9 from "../assets/images/team/pic9.jpg";
import image_team_pic10 from "../assets/images/team/pic10.jpg";
import image_team_pic11 from "../assets/images/team/pic11.jpg";
import image_team_pic12 from "../assets/images/team/pic12.jpg";
import blog_grid_pic1 from "../assets/images/blog/grid/pic1.jpg";
import blog_grid_pic2 from "../assets/images/blog/grid/pic2.jpg";
import blog_grid_pic3 from "../assets/images/blog/grid/pic3.jpg";
import blog_grid_pic4 from "../assets/images/blog/grid/pic4.jpg";
import blog_grid_pic5 from "../assets/images/blog/grid/pic5.jpg";
import blog_grid_pic6 from "../assets/images/blog/grid/pic6.jpg";
import blog_grid_pic7 from "../assets/images/blog/grid/pic7.jpg";
import blog_grid_pic8 from "../assets/images/blog/grid/pic8.jpg";
import background_pic5 from "../assets/images/background/pic5.png";
import background_pic6 from "../assets/images/background/pic6.png";
import main_slider2_bg1 from "../assets/images/main-slider/slider2/bg1.jpg";
import main_slider2_line from "../assets/images/main-slider/slider2/line.png";
import main_slider2_pic1 from "../assets/images/main-slider/slider2/pic1.png";
import main_slider2_pic4 from "../assets/images/main-slider/slider2/pic4.png";
import main_slider2_pic2 from "../assets/images/main-slider/slider2/pic2.png";
import main_slider2_bg2 from "../assets/images/main-slider/slider2/bg2.jpg";
import main_slider2_bg3 from "../assets/images/main-slider/slider2/bg3.jpg";
import main_slider2_pic3 from "../assets/images/main-slider/slider2/pic3.png";
import menu_small_pic1 from "../assets/images/menu-small/pic1.png";
import menu_small_pic2 from "../assets/images/menu-small/pic2.png";
import menu_small_pic3 from "../assets/images/menu-small/pic3.png";
import menu_small_pic4 from "../assets/images/menu-small/pic4.png";
import menu_small_pic5 from "../assets/images/menu-small/pic5.png";
import menu_small_pic6 from "../assets/images/menu-small/pic6.png";
import menu_small_pic7 from "../assets/images/menu-small/pic7.png";
import menu_small_pic8 from "../assets/images/menu-small/pic8.png";
import menu_small_pic9 from "../assets/images/menu-small/pic9.png";
import menu_small_pic10 from "../assets/images/menu-small/pic10.png";
import menu_small_pic11 from "../assets/images/menu-small/pic11.png";
import menu_small_pic12 from "../assets/images/menu-small/pic12.png";
import menu_small_pic13 from "../assets/images/menu-small/pic13.png";
import menu_small_pic14 from "../assets/images/menu-small/pic14.png";
import menu_small_pic15 from "../assets/images/menu-small/pic15.png";
import gallery_grid3_pic1 from "../assets/images/gallery/grid3/pic1.jpg";
import gallery_grid3_pic2 from "../assets/images/gallery/grid3/pic2.jpg";
import gallery_grid3_pic3 from "../assets/images/gallery/grid3/pic3.jpg";
import gallery_grid3_pic4 from "../assets/images/gallery/grid3/pic4.jpg";
import menu_small_grid_pic1 from "../assets/images/menu-small/grid/pic1.png";
import menu_small_grid_pic2 from "../assets/images/menu-small/grid/pic2.png";
import menu_small_grid_pic3 from "../assets/images/menu-small/grid/pic3.png";
import menu_small_grid_pic4 from "../assets/images/menu-small/grid/pic4.png";
import menu_small_grid_pic5 from "../assets/images/menu-small/grid/pic5.png";
import menu_small_grid_pic6 from "../assets/images/menu-small/grid/pic6.png";
import menu_small_grid_pic7 from "../assets/images/menu-small/grid/pic7.png";
import menu_small_grid_pic8 from "../assets/images/menu-small/grid/pic8.png";
import background_pic10 from "../assets/images/background/pic10.png";
import testimonial_large_pic1 from "../assets/images/testimonial/large/pic1.jpg";
import testimonial_large_pic2 from "../assets/images/testimonial/large/pic2.jpg";
import testimonial_large_pic3 from "../assets/images/testimonial/large/pic3.jpg";
import blog_grid2_pic1 from "../assets/images/blog/grid2/pic1.jpg";
import blog_grid2_pic2 from "../assets/images/blog/grid2/pic2.jpg";
import video from "../assets/video/video.mp4";
import blog_large_pic1 from "../assets/images/blog/large/pic1.jpg";
import main_slider3_bg from "../assets/images/main-slider/slider3/bg.png";
import main_slider3_offer from "../assets/images/main-slider/slider3/offer.png";
import main_slider3_crown from "../assets/images/main-slider/slider3/crown.png";
import main_slider3_burger from "../assets/images/main-slider/slider3/burger.png";
import images_adv_pic2 from "../assets/images/adv/pic2.png";
import images_adv_pic3 from "../assets/images/adv/pic3.png";
import images_adv_pic1 from "../assets/images/adv/pic1.png";
import images_adv_label from "../assets/images/adv/label.png";
import images_adv_media from "../assets/images/adv-media.jpg";
import background_pic15 from "../assets/images/background/pic15.png";
import background_pic16 from "../assets/images/background/pic16.png";
import images_adv_pic4 from "../assets/images/adv/pic4.png";
import images_gallery_grid4_pic1 from "../assets/images/gallery/grid4/pic1.jpg";
import images_gallery_grid4_pic2 from "../assets/images/gallery/grid4/pic2.jpg";
import images_gallery_grid4_pic3 from "../assets/images/gallery/grid4/pic3.jpg";
import images_gallery_grid4_pic4 from "../assets/images/gallery/grid4/pic4.jpg";
import images_gallery_grid4_pic5 from "../assets/images/gallery/grid4/pic5.jpg";
import images_gallery_grid4_pic6 from "../assets/images/gallery/grid4/pic6.jpg";
import images_background_pic13 from "../assets/images/background/pic13.png";
import background_pic11 from "../assets/images/background/pic11.jpg";
import banner_bnr1 from "../assets/images/banner/bnr1.jpg";
import banner_bnr2 from "../assets/images/banner/bnr2.jpg";
import faq_pic1 from "../assets/images/faq/pic1.png";
import images_bnr4 from "../assets/images/banner/bnr4.jpg";
import team_detail_pic1 from "../assets/images/team/detail/pic1.jpg";
import gallery_grid5_pic1 from "../assets/images/gallery/grid5/pic1.jpg";
import gallery_grid5_pic2 from "../assets/images/gallery/grid5/pic2.jpg";
import gallery_grid5_pic3 from "../assets/images/gallery/grid5/pic3.jpg";
import gallery_grid5_pic4 from "../assets/images/gallery/grid5/pic4.jpg";
import gallery_grid5_pic5 from "../assets/images/gallery/grid5/pic5.jpg";
import gallery_grid5_pic6 from "../assets/images/gallery/grid5/pic6.jpg";
import gallery_grid5_pic7 from "../assets/images/gallery/grid5/pic7.jpg";
import gallery_grid5_pic8 from "../assets/images/gallery/grid5/pic8.jpg";
import gallery_grid5_pic9 from "../assets/images/gallery/grid5/pic9.jpg";
import gallery_grid5_pic10 from "../assets/images/gallery/grid5/pic10.jpg";
import gallery_grid5_pic11 from "../assets/images/gallery/grid5/pic11.jpg";
import gallery_grid5_pic12 from "../assets/images/gallery/grid5/pic12.jpg";
import images_bnr5 from "../assets/images/banner/bnr5.jpg";
import blog_detail_pic2 from "../assets/images/blog/detail/pic2.jpg";
import blog_recent_pic4 from "../assets/images/blog/recent-blog/pic4.jpg";
import blog_recent_pic5 from "../assets/images/blog/recent-blog/pic5.jpg";
import background_bg1 from "../assets/images/background/bg1.jpg";
import background_pic17 from "../assets/images/background/pic17.png";
import background_pic18 from "../assets/images/background/pic18.png";
import background_pic12 from "../assets/images/background/pic12.png";
import background_pic14 from "../assets/images/background/pic14.png";
import images_bnr3 from "../assets/images/banner/bnr3.jpg";
import shop_pic1 from "../assets/images/shop/pic1.jpg";
import shop_pic4 from "../assets/images/shop/pic4.jpg";
import modal_pic1 from "../assets/images/modal/pic1.jpg";
import modal_mini_pic1 from "../assets/images/modal/mini/pic1.jpg";
import modal_mini_pic2 from "../assets/images/modal/mini/pic2.jpg";
import modal_mini_pic3 from "../assets/images/modal/mini/pic3.jpg";
import modal_mini_pic4 from "../assets/images/modal/mini/pic4.jpg";
import testimonial_mini_pic1 from "../assets/images/testimonial/mini/pic1.jpg";
import testimonial_mini_pic2 from "../assets/images/testimonial/mini/pic2.jpg";
import testimonial_mini_pic3 from "../assets/images/testimonial/mini/pic3.jpg";
import blog_grid3_pic1 from "../assets/images/blog/grid3/pic1.jpg";
import blog_grid3_pic2 from "../assets/images/blog/grid3/pic2.jpg";
import blog_grid3_pic3 from "../assets/images/blog/grid3/pic3.jpg";
import blog_grid3_pic4 from "../assets/images/blog/grid3/pic4.jpg";
import blog_grid3_pic5 from "../assets/images/blog/grid3/pic5.jpg";
import blog_grid3_pic6 from "../assets/images/blog/grid3/pic6.jpg";
import blog_grid3_pic7 from "../assets/images/blog/grid3/pic7.jpg";
import blog_grid3_pic8 from "../assets/images/blog/grid3/pic8.jpg";
import recent_blog_pic1 from "../assets/images/blog/recent-blog/pic1.jpg";
import recent_blog_pic2 from "../assets/images/blog/recent-blog/pic2.jpg";
import recent_blog_pic3 from "../assets/images/blog/recent-blog/pic3.jpg";
import blog_detail_pic1 from "../assets/images/blog/detail/pic1.jpg";
import background_pic21 from "../assets/images/background/pic21.png";
import blog_detail_pic3 from "../assets/images/blog/detail/pic3.jpg";
import blog_detail_pic4 from "../assets/images/blog/detail/pic4.jpg";
import blog_detail_pic5 from "../assets/images/blog/detail/pic5.jpg";
import blog_detail_pic6 from "../assets/images/blog/detail/pic6.jpg";
import blog_detail_pic7 from "../assets/images/blog/detail/pic7.jpg";
import background_pic20 from "../assets/images/background/pic20.png";
import blog_detail_author from "../assets/images/blog/detail/author.jpg";
import blog_detail_signin from "../assets/images/blog/detail/signing.png";

import switcher_small_bg1 from "../assets/images/switcher/small/background/bg1.jpg";
import switcher_small_bg2 from "../assets/images/switcher/small/background/bg2.jpg";
import switcher_small_bg3 from "../assets/images/switcher/small/background/bg3.jpg";
import switcher_small_bg4 from "../assets/images/switcher/small/background/bg4.jpg";
import switcher_small_bg5 from "../assets/images/switcher/small/background/bg5.jpg";
import switcher_small_bg6 from "../assets/images/switcher/small/background/bg6.jpg";
import switcher_small_bg7 from "../assets/images/switcher/small/background/bg7.jpg";

import switcher_large_bg1 from "../assets/images/switcher/large/background/bg1.jpg";
import switcher_large_bg2 from "../assets/images/switcher/large/background/bg2.jpg";
import switcher_large_bg3 from "../assets/images/switcher/large/background/bg3.jpg";
import switcher_large_bg4 from "../assets/images/switcher/large/background/bg4.jpg";
import switcher_large_bg5 from "../assets/images/switcher/large/background/bg5.jpg";
import switcher_large_bg6 from "../assets/images/switcher/large/background/bg6.jpg";
import switcher_large_bg7 from "../assets/images/switcher/large/background/bg7.jpg";

import switcher_small_pt1 from "../assets/images/switcher/small/pattern/pt1.jpg";
import switcher_small_pt2 from "../assets/images/switcher/small/pattern/pt2.jpg";
import switcher_small_pt3 from "../assets/images/switcher/small/pattern/pt3.jpg";
import switcher_small_pt4 from "../assets/images/switcher/small/pattern/pt4.jpg";
import switcher_small_pt5 from "../assets/images/switcher/small/pattern/pt5.jpg";
import switcher_small_pt6 from "../assets/images/switcher/small/pattern/pt6.jpg";
import switcher_small_pt7 from "../assets/images/switcher/small/pattern/pt7.jpg";

import switcher_large_pt1 from "../assets/images/switcher/large/pattern/pt1.jpg";
import switcher_large_pt2 from "../assets/images/switcher/large/pattern/pt2.jpg";
import switcher_large_pt3 from "../assets/images/switcher/large/pattern/pt3.jpg";
import switcher_large_pt4 from "../assets/images/switcher/large/pattern/pt4.jpg";
import switcher_large_pt5 from "../assets/images/switcher/large/pattern/pt5.jpg";
import switcher_large_pt6 from "../assets/images/switcher/large/pattern/pt6.jpg";
import switcher_large_pt7 from "../assets/images/switcher/large/pattern/pt7.jpg";
import noodleImage from "../assets/images/banner/noodles.png"

import duck1 from "../assets/images/client/duck1.png"
import duck2 from "../assets/images/client/duck2.png"
import duck3 from "../assets/images/client/duck3.png"
import duck4 from "../assets/images/client/duck4.png"
import duck5 from "../assets/images/client/duck5.png"
import duck6 from "../assets/images/client/duck6.png"
import duck7 from "../assets/images/client/duck7.png"
import duck8 from "../assets/images/client/duck8.png"
import duck9 from "../assets/images/client/duck9.png"
import duck10 from "../assets/images/client/duck10.png"
import duck11 from "../assets/images/client/duck11.png"


export const IMAGES = {
  duck1: duck1,
  duck2: duck2,
  duck3: duck3,
  duck4: duck4,
  duck5: duck5,
  duck6: duck6,
  duck7: duck7,
  duck8 : duck8,
  duck9 : duck9,
  duck10 : duck10,
  duck11 : duck11,
  noodle: noodleImage,
  logo: logo,
  logo2: logo2,
  shop_pic2: shop_pic2,
  shop_pic3: shop_pic3,
  main_slide_pic1: main_slide_pic1,
  main_slide_img1: main_slide_img1,
  main_slide_img2: main_slide_img2,
  main_slide_img3: main_slide_img3,
  main_slide_thumb_pic1: main_slide_thumb_pic1,
  main_slide_thumb_pic2: main_slide_thumb_pic2,
  main_slide_thumb_pic3: main_slide_thumb_pic3,
  background_pic2: background_pic2,
  background_pic3: background_pic3,
  background_pic4: background_pic4,
  gallery_small_pic1: gallery_small_pic1,
  gallery_small_pic2: gallery_small_pic2,
  gallery_small_pic3: gallery_small_pic3,
  gallery_small_pic4: gallery_small_pic4,
  gallery_small_pic5: gallery_small_pic5,
  gallery_small_pic6: gallery_small_pic6,
  gallery_small_pic7: gallery_small_pic7,
  gallery_small_pic8: gallery_small_pic8,
  gallery_small_pic9: gallery_small_pic9,
  gallery_small_pic10: gallery_small_pic10,
  gallery_small_pic11: gallery_small_pic11,
  gallery_small_pic12: gallery_small_pic12,

  gallery_grid_pic1: gallery_grid_pic1,
  gallery_grid_pic2: gallery_grid_pic2,
  gallery_grid_pic3: gallery_grid_pic3,
  gallery_grid_pic4: gallery_grid_pic4,
  gallery_grid_pic5: gallery_grid_pic5,
  gallery_grid_pic6: gallery_grid_pic6,
  gellry_grid2_pic1: gellry_grid2_pic1,
  gellry_grid2_pic2: gellry_grid2_pic2,
  gellry_grid2_pic3: gellry_grid2_pic3,
  gellry_grid2_pic4: gellry_grid2_pic4,
  background_pic1: background_pic1,
  testiminial_small_pic1: testiminial_small_pic1,
  testiminial_small_pic2: testiminial_small_pic2,
  testiminial_small_pic3: testiminial_small_pic3,
  testiminial_small_pic4: testiminial_small_pic4,
  testiminial_small_pic5: testiminial_small_pic5,
  testiminial_small_pic6: testiminial_small_pic6,
  image_team_pic1: image_team_pic1,
  image_team_pic2: image_team_pic2,
  image_team_pic3: image_team_pic3,
  image_team_pic4: image_team_pic4,
  image_team_pic5: image_team_pic5,
  image_team_pic6: image_team_pic6,
  image_team_pic7: image_team_pic7,
  image_team_pic8: image_team_pic8,
  image_team_pic9: image_team_pic9,
  image_team_pic10: image_team_pic10,
  image_team_pic11: image_team_pic11,
  image_team_pic12: image_team_pic12,
  blog_grid_pic1: blog_grid_pic1,
  blog_grid_pic2: blog_grid_pic2,
  blog_grid_pic3: blog_grid_pic3,
  blog_grid_pic4: blog_grid_pic4,
  blog_grid_pic5: blog_grid_pic5,
  blog_grid_pic6: blog_grid_pic6,
  blog_grid_pic7: blog_grid_pic7,
  blog_grid_pic8: blog_grid_pic8,
  background_pic5: background_pic5,
  background_pic6: background_pic6,
  main_slider2_bg1: main_slider2_bg1,
  main_slider2_line: main_slider2_line,
  main_slider2_pic1: main_slider2_pic1,
  main_slider2_pic4: main_slider2_pic4,
  main_slider2_pic2: main_slider2_pic2,
  main_slider2_bg2: main_slider2_bg2,
  main_slider2_bg3: main_slider2_bg3,
  main_slider2_pic3: main_slider2_pic3,
  menu_small_pic1: menu_small_pic1,
  menu_small_pic2: menu_small_pic2,
  menu_small_pic3: menu_small_pic3,
  menu_small_pic4: menu_small_pic4,
  menu_small_pic5: menu_small_pic5,
  menu_small_pic6: menu_small_pic6,
  menu_small_pic7: menu_small_pic7,
  menu_small_pic8: menu_small_pic8,
  menu_small_pic9: menu_small_pic9,
  menu_small_pic10: menu_small_pic10,
  menu_small_pic11: menu_small_pic11,
  menu_small_pic12: menu_small_pic12,
  menu_small_pic13: menu_small_pic13,
  menu_small_pic14: menu_small_pic14,
  menu_small_pic15: menu_small_pic15,
  gallery_grid3_pic1: gallery_grid3_pic1,
  gallery_grid3_pic2: gallery_grid3_pic2,
  gallery_grid3_pic3: gallery_grid3_pic3,
  gallery_grid3_pic4: gallery_grid3_pic4,
  menu_small_grid_pic1: menu_small_grid_pic1,
  menu_small_grid_pic2: menu_small_grid_pic2,
  menu_small_grid_pic3: menu_small_grid_pic3,
  menu_small_grid_pic4: menu_small_grid_pic4,
  menu_small_grid_pic5: menu_small_grid_pic5,
  menu_small_grid_pic6: menu_small_grid_pic6,
  menu_small_grid_pic7: menu_small_grid_pic7,
  menu_small_grid_pic8: menu_small_grid_pic8,
  background_pic10: background_pic10,
  testimonial_large_pic1: testimonial_large_pic1,
  testimonial_large_pic2: testimonial_large_pic2,
  testimonial_large_pic3: testimonial_large_pic3,
  blog_grid2_pic1: blog_grid2_pic1,
  blog_grid2_pic2: blog_grid2_pic2,
  video: video,
  blog_large_pic1: blog_large_pic1,
  main_slider3_bg: main_slider3_bg,
  main_slider3_offer: main_slider3_offer,
  main_slider3_crown: main_slider3_crown,
  main_slider3_burger: main_slider3_burger,
  images_adv_pic2: images_adv_pic2,
  images_adv_pic1: images_adv_pic1,
  images_adv_label: images_adv_label,
  images_adv_pic3: images_adv_pic3,
  images_adv_media: images_adv_media,
  background_pic15: background_pic15,
  background_pic16: background_pic16,
  images_adv_pic4: images_adv_pic4,
  images_gallery_grid4_pic1: images_gallery_grid4_pic1,
  images_gallery_grid4_pic2: images_gallery_grid4_pic2,
  images_gallery_grid4_pic3: images_gallery_grid4_pic3,
  images_gallery_grid4_pic4: images_gallery_grid4_pic4,
  images_gallery_grid4_pic5: images_gallery_grid4_pic5,
  images_gallery_grid4_pic6: images_gallery_grid4_pic6,
  images_background_pic13: images_background_pic13,
  banner_bnr1: banner_bnr1,
  background_pic11: background_pic11,
  banner_bnr2: banner_bnr2,
  faq_pic1: faq_pic1,
  images_bnr4: images_bnr4,
  team_detail_pic1: team_detail_pic1,
  gallery_grid5_pic1: gallery_grid5_pic1,
  gallery_grid5_pic2: gallery_grid5_pic2,
  gallery_grid5_pic3: gallery_grid5_pic3,
  gallery_grid5_pic4: gallery_grid5_pic4,
  gallery_grid5_pic5: gallery_grid5_pic5,
  gallery_grid5_pic6: gallery_grid5_pic6,
  gallery_grid5_pic7: gallery_grid5_pic7,
  gallery_grid5_pic8: gallery_grid5_pic8,
  gallery_grid5_pic9: gallery_grid5_pic9,
  gallery_grid5_pic10: gallery_grid5_pic10,
  gallery_grid5_pic11: gallery_grid5_pic11,
  gallery_grid5_pic12: gallery_grid5_pic12,
  images_bnr5: images_bnr5,
  blog_detail_pic2: blog_detail_pic2,
  blog_recent_pic4: blog_recent_pic4,
  blog_recent_pic5: blog_recent_pic5,
  background_bg1: background_bg1,
  background_pic17: background_pic17,
  background_pic18: background_pic18,
  background_pic12: background_pic12,
  background_pic14: background_pic14,
  images_bnr3: images_bnr3,
  shop_pic1: shop_pic1,
  shop_pic4: shop_pic4,
  modal_pic1: modal_pic1,
  modal_mini_pic1: modal_mini_pic1,
  modal_mini_pic2: modal_mini_pic2,
  modal_mini_pic3: modal_mini_pic3,
  modal_mini_pic4: modal_mini_pic4,
  testimonial_mini_pic1: testimonial_mini_pic1,
  testimonial_mini_pic2: testimonial_mini_pic2,
  testimonial_mini_pic3: testimonial_mini_pic3,
  blog_grid3_pic1: blog_grid3_pic1,
  blog_grid3_pic2: blog_grid3_pic2,
  blog_grid3_pic3: blog_grid3_pic3,
  blog_grid3_pic4: blog_grid3_pic4,
  blog_grid3_pic5: blog_grid3_pic5,
  blog_grid3_pic6: blog_grid3_pic6,
  blog_grid3_pic7: blog_grid3_pic7,
  blog_grid3_pic8: blog_grid3_pic8,
  recent_blog_pic1: recent_blog_pic1,
  recent_blog_pic2: recent_blog_pic2,
  recent_blog_pic3: recent_blog_pic3,
  blog_detail_pic1: blog_detail_pic1,
  background_pic21: background_pic21,
  blog_detail_pic3: blog_detail_pic3,
  blog_detail_pic4: blog_detail_pic4,
  blog_detail_pic5: blog_detail_pic5,
  blog_detail_pic6: blog_detail_pic6,
  blog_detail_pic7: blog_detail_pic7,
  background_pic20: background_pic20,
  blog_detail_author: blog_detail_author,
  blog_detail_signin: blog_detail_signin,

  switcher_small_bg1: switcher_small_bg1,
  switcher_small_bg2: switcher_small_bg2,
  switcher_small_bg3: switcher_small_bg3,
  switcher_small_bg4: switcher_small_bg4,
  switcher_small_bg5: switcher_small_bg5,
  switcher_small_bg6: switcher_small_bg6,
  switcher_small_bg7: switcher_small_bg7,

  switcher_large_bg1: switcher_large_bg1,
  switcher_large_bg2: switcher_large_bg2,
  switcher_large_bg3: switcher_large_bg3,
  switcher_large_bg4: switcher_large_bg4,
  switcher_large_bg5: switcher_large_bg5,
  switcher_large_bg6: switcher_large_bg6,
  switcher_large_bg7: switcher_large_bg7,

  switcher_small_pt1: switcher_small_pt1,
  switcher_small_pt2: switcher_small_pt2,
  switcher_small_pt3: switcher_small_pt3,
  switcher_small_pt4: switcher_small_pt4,
  switcher_small_pt5: switcher_small_pt5,
  switcher_small_pt6: switcher_small_pt6,
  switcher_small_pt7: switcher_small_pt7,

  switcher_large_pt1: switcher_large_pt1,
  switcher_large_pt2: switcher_large_pt2,
  switcher_large_pt3: switcher_large_pt3,
  switcher_large_pt4: switcher_large_pt4,
  switcher_large_pt5: switcher_large_pt5,
  switcher_large_pt6: switcher_large_pt6,
  switcher_large_pt7: switcher_large_pt7,
};
